import { NgStyle } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ChatbotConfig, SpfBucketFileFrontend } from '@shared/index';
import { getContrastColorSafe } from '@shared-angular';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ToastrService } from '@shared-angular/services/toastr.service';
import { BotQuickinfoComponent } from '../../../shared/components/ai-bot/utils/bot-quickinfo/bot-quickinfo.component';
import { SharetokenService } from '../../../shared/services/sharetoken.service';
import { BotImportApiResponse, BotImportFailureReport } from '@shared-angular/services/bot-import.types';

export type ShareBot = {
  name: string;
  icon: string;
  color: string;
};

@Component({
  templateUrl: './import.component.html',
  styleUrl: './import.component.scss',
  imports: [RouterLink, NgStyle,  BotQuickinfoComponent, ButtonModule, DialogModule]
})
export class ImportComponent implements OnInit {
  private shareToken: string = '';
  public invalidToken: boolean = false;
  public botConfig: ChatbotConfig | undefined;
  public botDocs: SpfBucketFileFrontend[] = [];
  public sharedBot: ShareBot = {
    name: '',
    icon: '',
    color: ''
  };
  public importing: boolean = false;
  public importErrorDialogVisible = false;
  public importFailureMessage = '';
  public importFailureReport: BotImportFailureReport | null = null;

  public getContrastColor = getContrastColorSafe;

  constructor(
    private route: ActivatedRoute,
    private SharetokenService: SharetokenService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  public async ngOnInit(): Promise<void> {
    this.shareToken = this.route.snapshot.params['token'] as string;
    await this.getShareTokenInfo(this.shareToken);
  }

  public async importBot() {
    this.importing = true;
    const res = await this.SharetokenService.ImportBot(this.shareToken);
    if (res.status === 'ok') {
      this.toastr.success("IMPORTED");
      await this.router.navigate(['/bot-admin/']);
    } else {
      this.showImportError(res);
    }
    this.importing = false;
  }

  public hasImportReportContent(): boolean {
    if (!this.importFailureReport) {
      return false;
    }
    return this.importFailureReport.errors.length > 0 || this.importFailureReport.cleanupWarnings.length > 0;
  }

  private showImportError(response: BotImportApiResponse): void {
    const message = response.message ?? $localize`:@@import-aborted-generic:Der Import wurde abgebrochen. Es wurden keine Änderungen gespeichert.`;
    this.toastr.error('IMPORTED', message);
    this.importFailureMessage = message;
    this.importFailureReport = response.report ?? null;
    this.importErrorDialogVisible = this.hasImportReportContent();
  }

  public async getShareTokenInfo(token: string) {
    const config = await this.SharetokenService.getShareTokenInfo(token);
    if (config) {
      this.botConfig = config.botconfig;
      this.botDocs = config.docs;
      this.sharedBot.name = config.botconfig.name;
      this.sharedBot.icon = config.botconfig.icon ?? "";
      this.sharedBot.color = config.botconfig.color;
    } else {
      this.invalidToken = true;
    }
  }
}
